import React, { ReactNode, useEffect, useRef, useState } from "react";
import ArrowDropDownIcon from "../../../shared/components/icons/ArrowDropDownIcon";
import ArrowDropUpIcon from "../../../shared/components/icons/ArrowDropUpIcon";

import { Box } from "../../../shared/components/ui/chakra";
import { HStack, Stack, Text } from "@chakra-ui/react";

const ExpandableText = ({
  children,
  showExpandButton = true,
  foldingMaxHeight,
  showExpandButtonLabel,
}: {
  children: ReactNode;
  showExpandButton?: boolean;
  foldingMaxHeight: number;
  showExpandButtonLabel: string;
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const [isOverFoldingMaxHeight, setIsOverFoldingMaxHeight] = useState(false);
  const [textHeight, setTextHeight] = useState(0);
  const textContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textContainerRef.current) {
      const height = textContainerRef.current.scrollHeight;
      setTextHeight(height);
      setIsOverFoldingMaxHeight(height > foldingMaxHeight);
    }
  }, [foldingMaxHeight]);

  return (
    <Stack alignItems="flex-end" gap={4}>
      <Box
        w="full"
        position="relative"
        overflow="hidden"
        sx={{
          transition: "max-height 0.5s cubic-bezier(0, 1, 0, 1)",
          transitionTimingFunction: expanded
            ? "ease-in-out"
            : "cubic-bezier(0, 1, 0, 1)",
          maxHeight: expanded
            ? `${textHeight + 20}px`
            : `${foldingMaxHeight}px`,
          "&::after": {
            content: !expanded && isOverFoldingMaxHeight ? '""' : "none",
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "40px",
            background:
              "linear-gradient(to top, white, rgba(255,255,255,0.7), transparent)",
          },
        }}
      >
        <div ref={textContainerRef}>
          <Text whiteSpace="pre-wrap" fontSize={{ base: "sm", md: "md" }}>
            {children}
          </Text>
        </div>
      </Box>

      {isOverFoldingMaxHeight && showExpandButton && (
        <HStack
          gap={1}
          onClick={() => setExpanded(!expanded)}
          cursor="pointer"
          _hover={{ textDecoration: "underline" }}
        >
          <Text fontSize="sm" fontWeight="bold" color="textLink" mt="1px">
            {expanded ? "閉じる" : showExpandButtonLabel}
          </Text>
          {expanded ? (
            <ArrowDropUpIcon color="textLink" w={5} h={5} />
          ) : (
            <ArrowDropDownIcon color="textLink" w={5} h={5} />
          )}
        </HStack>
      )}
    </Stack>
  );
};

export default ExpandableText;
